"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlagrContext = exports.FlagrProvider = void 0;
var react_1 = __importDefault(require("react"));
var user_data_provider_1 = require("../user-data-provider/user-data.provider");
var doolittle_featureflags_js_1 = __importDefault(require("@wn-doolittle/doolittle-featureflags-js"));
var config_provider_1 = require("../config/config.provider");
var FlagrContext = react_1.default.createContext(null);
exports.FlagrContext = FlagrContext;
function FlagrProvider(props) {
    var configContext = react_1.default.useContext(config_provider_1.ConfigContext);
    var userDataContext = react_1.default.useContext(user_data_provider_1.UserDataContext);
    var _a = react_1.default.useState(props.state || null), state = _a[0], setState = _a[1];
    react_1.default.useEffect(function () {
        function fetchFlagStates() {
            return __awaiter(this, void 0, void 0, function () {
                var newFlagsState;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(configContext === null)) return [3 /*break*/, 1];
                            console.error("FlagrProvider must be inside 'ConfigProvider'");
                            return [3 /*break*/, 4];
                        case 1:
                            if (!(Object.keys(userDataContext).length === 0)) return [3 /*break*/, 2];
                            console.warn('FlagrProvider requires UserDataContext to be populated');
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, getFlagStates(configContext.service.config.flagrServiceUrl, userDataContext, props.flagKeys)];
                        case 3:
                            newFlagsState = _a.sent();
                            setState(newFlagsState);
                            _a.label = 4;
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
        if (state === null) {
            fetchFlagStates();
        }
    }, [configContext, userDataContext, props.flagKeys, state]);
    return react_1.default.createElement(FlagrContext.Provider, { value: state },
        " ",
        props.children,
        " ");
}
exports.FlagrProvider = FlagrProvider;
function getFlagStates(apiPath, userData, flagKeys) {
    doolittle_featureflags_js_1.default.init({
        apiPath: apiPath,
        entityId: userData.username,
        entityType: userData.role,
        entityContext: {
            userId: userData.guid,
            schoolId: userData.schoolGuid,
            brand: userData.brand,
            role: userData.role,
        },
    });
    return doolittle_featureflags_js_1.default.load(flagKeys).then(function () {
        var flags = {};
        flagKeys.forEach(function (flag) {
            flags[flag] = doolittle_featureflags_js_1.default.flag(flag).isOn();
        });
        return flags;
    });
}
